import React, { Component } from 'react'
import { withRouter } from 'react-router'
import { Input, Button, Icon, Form, Select, Row, Col } from 'antd'
import { userRoles } from '@texts/users'
import { inject, observer } from 'mobx-react'

import * as style from './style.scss'
import ViewCode from '@pages/Clients/ViewCode'

@inject((store: any) => {
    const {
        popupStore,
        collectionsStore,
        recordsStore,
        doctorsStore,
        subscriptionsStore,
        authStore,
        clientsStore
    } = store
    return { popupStore, collectionsStore, recordsStore, doctorsStore, subscriptionsStore, authStore, clientsStore }
})
@observer
class SearchBar extends Component<any, any> {
    state = {
        phoneVerifyCode: '',
        phoneOld: '',
        phoneNew: ''
    }
    // Inputs are controlled; sanitize the value directly instead of reaching into
    // the DOM (getElementById fights React and is fragile if ids aren't unique).
    digitsOnly = value => (value || '').replace(/[^0-9]/g, '')

    updateField = (name, value) => {
        if (name === 'phone') {
            value = this.digitsOnly(value)
        }
        this.props.paramUpdated(name, value)
    }

    verifyPhone = phone => {
        this.setState({ phoneVerifyCode: this.digitsOnly(phone) })
    }

    oldPhone = phone => {
        this.setState({ phoneOld: this.digitsOnly(phone) })
    }

    newPhone = phone => {
        this.setState({ phoneNew: this.digitsOnly(phone) })
    }

    submitSearch = async e => {
        e.preventDefault()
        this.props.searchUpdated()
    }

    trimPhone = phone => {
        if (phone.length === 10 && phone[0] == 0) {
            return phone.substring(1)
        }
        return phone
    }

    phoneChangeHandler(): void {
        const { phoneOld, phoneNew } = this.state
        console.log(`new phone: ${phoneNew} old phone: ${phoneOld}`)

        this.props.clientsStore.updatePhone(this.trimPhone(phoneOld), phoneNew)
        this.setState({ phoneOld: '', phoneNew: '' })
    }
    validateSize = phone => phone.length >= 9

    render() {
        const {
            authStore: { roles },
            params,
            subscriptionsStore: { subscriptions }
        } = this.props
        const { phoneVerifyCode, phoneOld, phoneNew } = this.state

        return (
            <Form onSubmit={e => this.submitSearch(e)}>
                <Row
                    gutter={24}
                    style={{
                        backgroundColor: '#dbdfe5',
                        padding: '0.8rem 0.5rem',
                        display: 'flex',
                        justifyContent: 'space-between'
                    }}
                >
                    <Col sm={4} className={style.col}>
                        <label htmlFor="first_name">
                            <strong> על פי שם פרטי</strong>
                        </label>
                        <Input
                            id="first_name"
                            value={params['first_name'] ? params['first_name'] : null}
                            placeholder="הזן שם פרטי"
                            onChange={e => this.updateField('first_name', e.target.value)}
                        />
                    </Col>
                    <Col sm={4} className={style.col}>
                        <label htmlFor="last_name">
                            <strong> על פי שם משפחה</strong>
                        </label>
                        <Input
                            id="last_name"
                            value={params['last_name'] ? params['last_name'] : null}
                            placeholder="הזן שם משפחה"
                            onChange={e => this.updateField('last_name', e.target.value)}
                        />
                    </Col>
                    <Col sm={4} className={style.col}>
                        <label htmlFor="identity">
                            <strong>על פי ת״ז / דרכון</strong>
                        </label>
                        <Input
                            id="identity"
                            value={params['identity'] ? params['identity'] : null}
                            placeholder="הזן ת״ז / דרכון"
                            onChange={e => this.updateField('identity', e.target.value)}
                        />
                    </Col>
                    <Col sm={4} className={style.col}>
                        <label htmlFor="phone">
                            <strong> על פי טלפון</strong>
                        </label>
                        <Input
                            id="phone"
                            value={params['phone'] ? params['phone'] : null}
                            type="text"
                            placeholder="הזן מספר טלפון"
                            onChange={e => this.updateField('phone', e.target.value)}
                        />
                    </Col>
                    <Col sm={4} className={style.col}>
                        <label htmlFor="parent_id">
                            <strong>חיפוש משפחה (על פי מזהה ראשי)</strong>
                        </label>
                        <Input
                            id="parent_id"
                            value={params['parent_id'] ? params['parent_id'] : null}
                            type="number"
                            placeholder="הזן מזהה של המשתמש הראשי במשפחה"
                            onChange={e => this.updateField('parent_id', e.target.value)}
                        />
                    </Col>
                    <Col sm={4} className={style.col}>
                        <label htmlFor="email">
                            <strong>חיפוש על פי מייל</strong>
                        </label>
                        <Input
                            id="email"
                            value={params['email'] ? params['email'] : null}
                            type="text"
                            placeholder="הזן מייל"
                            onChange={e => this.updateField('email', e.target.value)}
                        />
                    </Col>
                </Row>
                <Row
                    gutter={24}
                    style={{
                        backgroundColor: '#dbdfe5',
                        padding: '0.8rem 0.5rem',
                        display: 'flex',
                        justifyContent: 'space-between'
                    }}
                >
                    <Col sm={4} className={style.col}>
                        <label>
                            <strong>סינון לפי תפקיד</strong>
                        </label>
                        <Select
                            placeholder="בחר תפקיד"
                            style={{ width: '100%' }}
                            value={params['slug'] ? params['slug'] : null}
                            onChange={e => this.updateField('slug', e)}
                        >
                            <Select.Option value={'customer'}>{userRoles.customer}</Select.Option>
                            <Select.Option value={'related'}>{userRoles.related}</Select.Option>
                            <Select.Option value={'subscriber'}>{userRoles.subscriber}</Select.Option>
                            <Select.Option value={'agent'}>{userRoles.agent}</Select.Option>
                            <Select.Option value={'insurance_agent'}>{userRoles.insurance_agent}</Select.Option>
                            <Select.Option value={'empty'}>ללא תפקיד</Select.Option>
                            <Select.Option value={null}>כולם </Select.Option>
                        </Select>
                    </Col>
                    <Col sm={4} className={style.col}>
                        <label>
                            <strong>סינון לפי סוג מנוי</strong>
                        </label>
                        <Select
                            placeholder="בחר סוג מנוי"
                            style={{ width: '100%' }}
                            value={params['subscription_id'] ? params['subscription_id'] : null}
                            onChange={e => this.updateField('subscription_id', e)}
                        >
                            <Select.Option value={null}>כולם </Select.Option>
                            {subscriptions
                                .filter(sub => sub.type != 'AGENT')
                                .map((subscription, index) => (
                                    <Select.Option key={index} value={subscription.id}>
                                        {subscription.name}
                                    </Select.Option>
                                ))}
                        </Select>
                    </Col>
                    <Col sm={4} className={style.colLast}>
                        <label>
                            <strong>סינון לפי סטטוס</strong>
                        </label>
                        <Select
                            placeholder="בחר סטטוס"
                            style={{ width: '100%' }}
                            value={params['status'] ? params['status'] : null}
                            onChange={e => this.updateField('status', e)}
                        >
                            <Select.Option value="DELETED">משתמשים שנמחקו</Select.Option>
                            <Select.Option value="COMPLETE">משתמשים פעילים</Select.Option>
                            <Select.Option value="INCOMPLETE">הרשמות לא הושלמו</Select.Option>
                            <Select.Option value="REGISTERED">משתמש רשום ללא הר הביטוח</Select.Option>
                            <Select.Option value="AWAITING_BANK_APPROVAL">ממתינים לאישור בנק</Select.Option>
                            <Select.Option value="WITHOUT_MENTOR">סוכנים/מפיצים ללא מנטור</Select.Option>
                            <Select.Option value={null}>כולם </Select.Option>
                        </Select>
                    </Col>
                    <Col sm={4} className={style.col}>
                        <label htmlFor="id">
                            <strong>חיפוש על פי מזהה משתמש</strong>
                        </label>
                        <Input
                            id="id"
                            value={params['id'] ? params['id'] : null}
                            type="number"
                            placeholder="הזן מזהה משתמש"
                            onChange={e => this.updateField('id', e.target.value)}
                        />
                    </Col>
                    <Col sm={4} className={style.colLast}>
                        <label htmlFor="agency_id">
                            <strong>חיפוש ע"פ מזהה סוכנות</strong>
                        </label>
                        <Input
                            id="agency_id"
                            value={params['agency_id'] ? params['agency_id'] : null}
                            type="number"
                            placeholder="הזן מזהה של סוכנות"
                            onChange={e => this.updateField('agency_id', e.target.value)}
                        />
                    </Col>
                    <Col sm={4} className={style.col}>
                        <label htmlFor="agent_id">
                            <strong>חיפוש לקוחות של סוכן</strong>
                        </label>
                        <Input
                            id="agent_id"
                            value={params['agent_id'] ? params['agent_id'] : null}
                            type="number"
                            placeholder="הזן מזהה סוכן"
                            onChange={e => this.updateField('agent_id', e.target.value)}
                        />
                    </Col>
                </Row>
                <Row style={{ marginTop: '1rem', textAlign: 'left' }}>
                    <Button onClick={() => this.props.resetSearch()}>
                        <span>איפוס חיפוש</span>
                    </Button>
                    <Button type="primary" htmlType="submit">
                        <Icon type="search" />
                        <span>חפש משתמשים</span>
                    </Button>
                    {!roles.includes('viewer') && (
                        <div style={{ marginTop: '1rem', textAlign: 'right' }}>
                            <Input
                                id="phone_verify_code"
                                value={phoneVerifyCode}
                                type="text"
                                placeholder="טלפון לקוד אימות"
                                onChange={e => this.verifyPhone(e.target.value)}
                                style={{ width: '10rem' }}
                            />
                            {phoneVerifyCode && this.validateSize(phoneVerifyCode) ? (
                                <ViewCode phone={phoneVerifyCode} />
                            ) : null}
                        </div>
                    )}
                    {(roles.includes('admin') || roles.includes('developer')) && (
                        <div>
                            <Input
                                id="phone_old"
                                value={phoneOld}
                                type="text"
                                placeholder="טלפון ישן"
                                onChange={e => this.oldPhone(e.target.value)}
                                style={{ width: '10rem' }}
                            />
                            <Input
                                id="phone_new"
                                value={phoneNew}
                                type="text"
                                placeholder=" טלפון חדש "
                                onChange={e => this.newPhone(e.target.value)}
                                style={{ width: '10rem' }}
                            />
                            <Button type="danger" onClick={() => this.phoneChangeHandler()}>
                                <span>תחליף</span>
                            </Button>
                        </div>
                    )}
                </Row>
            </Form>
        )
    }
}

export default withRouter(SearchBar)
